import React from 'react';
import ButtonSpinner from '../Loader/ButtonSpinner';
import { cn } from '../ui-x';

/** The reference's secondary: `variant="outline"` in navy. */
const OutlineButton = ({
  label,
  className,
  onClick,
  type = 'button',
  loading = false,
  disabled = false,
}) => {
  return (
    <button
      type={type}
      disabled={disabled}
      className={cn(
        'inline-flex h-9 items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-brand-navy px-4 text-sm font-semibold text-brand-navy transition-colors hover:bg-surface',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      onClick={onClick}
    >
      {label}
      {loading && <ButtonSpinner />}
    </button>
  );
};

export default OutlineButton;
